import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Card, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import FileViewer from "../Common/FileViewer";

const ViewDeletedReport = () => {
  const location = useLocation();
  const VisitId = JSON.parse(localStorage.getItem('report'));
  const [visitData, setVisitData] = useState(VisitId);
  
  // State for image modal
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage("");
  };

  return (
    <div className="visitReport">
      <Row className="mb-2 mt-4">
        <h4 className="mb-0 text-center">
          <Icon.FileText className="me-1" /> Deleted Report 
        </h4>
      </Row>
      <Row className="mb-2 mt-4">
        <Col md={2}>
          <Button className="backButton" onClick={() => window.history.back()}>
            <Icon.ArrowLeft size={20} className="me-2" /> Back
          </Button>
        </Col>
      </Row>
      
      <Card className="deleteCard">
        <Card.Header>
          <Card.Title>Bill Delete Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <b>Reason :- </b><span>{visitData?.deleteReason}</span>
        </Card.Body>
        <Card.Footer className="d-flex justify-content-between">
          <span>
            <b>Name :- </b>{visitData?.deleteName}
          </span>
          <span>
            <b>Mobile :- </b>{visitData?.deleteContactNo}
          </span>
        </Card.Footer>
        <Card.Footer className="d-flex justify-content-between">
          <span>
            <b>Role :- </b>{visitData?.deleteUserType}
          </span>
        </Card.Footer>
      </Card>
      
      <Row className="outer-wrapper mx-auto mt-4 mb-4">
        <div className="table-wrapper">
          <table data-aos="fade-up" data-aos-delay="200">
            <thead>
              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Code
                </th>
                <td>
                  {visitData?.propertyCode ? visitData?.propertyCode : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Owner Name
                </th>
                <td>
                  {visitData?.propertyName ? visitData?.propertyName : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Owner Mobile
                </th>
                <td>
                  {visitData?.mobileUpdated ? visitData?.mobileUpdated : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Address
                </th>
                <td style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                  {visitData?.propertyAddress ? visitData?.propertyAddress : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Category Name
                </th>
                <td>
                  {visitData?.propertyCategoryName ? visitData?.propertyCategoryName : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Property Image
                </th>
                <td>
                  {visitData?.propertyImg && visitData?.propertyImg.length > 0 ? (
                    <span 
                      style={{ cursor: "pointer" }}
                      onClick={() => handleImageClick(visitData?.propertyImg)}
                    >
                      <img 
                        src={visitData?.propertyImg} 
                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: "4px" }} 
                        alt="Property"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "https://cdn-icons-png.flaticon.com/512/972/972601.png";
                        }}
                      />
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>

              {/* Property Not Found Images - if they exist in the data structure */}
              {visitData?.propertyNotFoundImg && visitData?.propertyNotFoundImg.length > 0 && (
                <tr>
                  <th>
                    <Icon.Code className="me-2" />
                    Property Not Found Images
                  </th>
                  <td>
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                      {visitData?.propertyNotFoundImg?.map((img, index) => (
                        <span 
                          key={index} 
                          style={{ cursor: "pointer" }}
                          onClick={() => handleImageClick(img)}
                        >
                          <img
                            src={img}
                            style={{ width: 80, height: 80, objectFit: "cover", borderRadius: "4px" }}
                            alt={`Property Not Found ${index + 1}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "https://cdn-icons-png.flaticon.com/512/972/972601.png";
                            }}
                          />
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              )}

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Gat Name
                </th>
                <td>
                  {visitData?.gatname ? visitData?.gatname : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Zone Name
                </th>
                <td>
                  {visitData?.zonename ? visitData?.zonename : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Visit Person Name
                </th>
                <td>
                  {visitData?.visitingPersonName ? visitData?.visitingPersonName : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Visit Person Mobile
                </th>
                <td>
                  {visitData?.visitingPersonContactNo ? visitData?.visitingPersonContactNo : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" />
                  Upyog Karta Shulka Name
                </th>
                <td>
                  {visitData?.upayogakartaShulkName ? visitData?.upayogakartaShulkName : "-"}
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </Row>

      {/* Image Modal using FileViewer */}
      {showModal && (
        <FileViewer
          file={selectedImage}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ViewDeletedReport;